// extracted by mini-css-extract-plugin
export default {"bimContractAccumulationSheet":"BimContractAccumulationSheet_bimContractAccumulationSheet__mZckE"};